import { ThemeKey } from "@smartsheet/design-tokens";
import { Tokens } from "../types";

/**
 * A function to generate a collection of css variable tokens, abstracted for general use
 * from code in createTokenInjector.tsx
 */
export const getCSSVariables = (
    /**
     * A unique string (among all custom injectors) that helps avoid collisions in token names.
     * Since tokens are injected as CSS custom properties, they are all global.
     */
    namespace: string,

    themeKey: ThemeKey,
    /**
     * The set of Tokens to include in this injector.
     */
    tokens: Tokens //this arg comes from a file that is autogenerated and outputs the entire token list in readonly format
) => {
    // Create 2 things:
    // 1) a set of css custom properties to pass along to the injector
    const cssCustomProperties = {} as Record<string, string | number>;
    // 2) a dictionary of token names => the CSS custom property names from #1.
    const tokenNameLookup = {} as Record<string, string>;

    for (const token of tokens) {
        const tokenVariableName = `--smar--${namespace}--${token["name"]}`;
        // insert the variable name into the by-token-name lookup table.
        tokenNameLookup[token.name] = tokenVariableName;

        if (token.value[themeKey as keyof typeof token.value]) {
            // Insert the css custom property into the map for the DOM.
            cssCustomProperties[tokenVariableName] = token.value[themeKey as keyof typeof token.value];
        }
    }

    return cssCustomProperties;
};
